import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface EmptyStateProps {
  icon?: LucideIcon;
  title?: ReactNode;
  message: ReactNode;
  /** Action slot (typically a <Button>). */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, message, action, className }: EmptyStateProps) {
  return (
    <div
      className={twMerge(
        'bg-white rounded-card border border-legal-200 p-6 text-center animate-fade-in',
        className
      )}
    >
      {Icon && (
        <div className="flex justify-center mb-3">
          <div className="p-3 bg-legal-50 rounded-full">
            <Icon className="h-6 w-6 text-legal-400" />
          </div>
        </div>
      )}
      {title && <h3 className="text-base font-semibold text-legal-900 mb-1">{title}</h3>}
      <p className="text-sm text-legal-400">{message}</p>
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
